import { render, staticRenderFns } from "./JudicialRecoveryNavLink.vue?vue&type=template&id=7b7ccc9c&"
import script from "./JudicialRecoveryNavLink.vue?vue&type=script&lang=js&"
export * from "./JudicialRecoveryNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
